// 状态管理
const state = {
    ws: null,
    callbacks: new Map()  // 使用 type_identifier 作为 key 存储回调
};

// 修改状态的方法
const mutations = {
    SET_WEBSOCKET(state, ws) {
        state.ws = ws;
    },
};

// 异步操作和复杂逻辑
const actions = {
    // 建立全局连接
    async connect({ commit, state, rootGetters }) {
        if (state.ws?.readyState === WebSocket.OPEN) {
            return;
        }
        // 根据环境使用不同的前缀
        const host = window.location.host;
        const wsPrefix = process.env.NODE_ENV === 'production' ? '/api' : '/dev';
        // 使用相对路径，通过当前域名连接WebSocket
        const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
        
        // 使用查询参数传递token
        const wsUrl = `${protocol}//${host}${wsPrefix}/ws/global`;
        const ws = new WebSocket(wsUrl);
        
        // 设置消息处理
        ws.onmessage = (event) => {
            const data = event.data;
            if (typeof data === 'string' && !data.startsWith('{')) {
                return; // 处理心跳等简单消息
            }
            try {
                const message = JSON.parse(data);
                const key = `${message.type}_${message.identifier}`;
                const callback = state.callbacks.get(key);
                if (callback) {
                    callback(message);
                }
            } catch (error) {
                console.error('处理消息失败:', error);
            }
        };

        commit('SET_WEBSOCKET', ws);
    },

    // 注册消息处理回调
    register({ state }, { type, identifier, callback }) {
        const key = `${type}_${identifier}`;
        state.callbacks.set(key, callback);
        
        // 发送订阅消息
        if (state.ws?.readyState === WebSocket.OPEN) {
            state.ws.send(`subscribe:${type}:${identifier}`);
        }
    },

    // 注销消息处理回调
    unregister({ state }, { type, identifier }) {
        const key = `${type}_${identifier}`;
        state.callbacks.delete(key);
        
        // 发送取消订阅消息
        if (state.ws?.readyState === WebSocket.OPEN) {
            state.ws.send(`unsubscribe:${type}:${identifier}`);
        }
    }
};

// 计算属性
const getters = {
    isConnected: state => state.ws?.readyState === WebSocket.OPEN,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}; 